import { getGoToTodayMenuItem } from '../commandBarItems/getGoToTodayMenuItem';
import { getSurfaceShareMenuItem } from '../commandBarItems/surface/getSurfaceShareMenuItem';
import { getViewSwitcherMenuItem } from '../commandBarItems/getViewSwitcherMenuItem';
import type { CalendarModuleCommandBarConfig } from '../schema';
import { getSurfaceNavigationMenuItems } from '../commandBarItems/surface/getSurfaceNavigationMenuItems';
import { getSurfacePrintMenuItem } from '../commandBarItems/surface/getSurfacePrintMenuItem';
import { getSurfaceTimestripMenuItem } from '../commandBarItems/surface/getSurfaceTimestripMenuItem';
import { shouldSurfaceNavigationBarAppear } from 'owa-calendar-layout';

export function getSurfaceCommandBarConfig(
    onCustomRenderSubMenuChange: () => void
): CalendarModuleCommandBarConfig {
    const primaryItems = shouldSurfaceNavigationBarAppear()
        ? []
        : [
              getGoToTodayMenuItem(),
              ...getSurfaceNavigationMenuItems(),
              getSurfaceTimestripMenuItem(),
          ];

    return {
        primaryItems: primaryItems,
        farItems: [
            getViewSwitcherMenuItem(onCustomRenderSubMenuChange),
            getSurfaceShareMenuItem(),
            getSurfacePrintMenuItem(),
        ],
    };
}
